import { render } from "./DocentiView.vue?vue&type=template&id=1d524a6b"
import script from "./DocentiView.vue?vue&type=script&lang=js"
export * from "./DocentiView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__